import { JobInfoWrapper } from "@/components/wrappers";

interface JobInfoProps {
  icon: React.ReactNode;
  text: string;
}

const JobInfo = ({ icon, text }: JobInfoProps) => {
  return (
    <JobInfoWrapper>
      <span className="job-icon">{icon}</span>
      <span className="job-text">{text}</span>
    </JobInfoWrapper>
  );
};

export default JobInfo;
